module.exports = __webpack_public_path__ + "img/ewm3.71fb91cb.jpg";